var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9585 18.9999C3.9585 11.9092 3.9585 8.36386 6.16129 6.16105C8.36411 3.95825 11.9095 3.95825 19.0002 3.95825C26.0908 3.95825 29.6362 3.95825 31.8391 6.16105C34.0418 8.36386 34.0418 11.9092 34.0418 18.9999C34.0418 26.0906 34.0418 29.636 31.8391 31.8389C29.6362 34.0416 26.0908 34.0416 19.0002 34.0416C11.9095 34.0416 8.36411 34.0416 6.16129 31.8389C3.9585 29.636 3.9585 26.0906 3.9585 18.9999Z",
    fill: "#AC3838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6757 19.625C23.4359 20.6173 22.3024 21.3185 20.0353 22.7211C17.8437 24.0767 16.748 24.7547 15.8648 24.4822C15.4998 24.3695 15.1671 24.1556 14.8989 23.8607C14.25 23.1479 14.25 21.7652 14.25 18.9999C14.25 16.2346 14.25 14.8519 14.8989 14.139C15.1671 13.8443 15.4998 13.6303 15.8648 13.5177C16.748 13.2452 17.8437 13.9231 20.0353 15.2788C22.3024 16.6813 23.4359 17.3825 23.6757 18.3748C23.7747 18.7844 23.7747 19.2154 23.6757 19.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.33e126b431c1e50c6ad27ec659aaaf3e.svg";
export { ForwardRef as ReactComponent };